import { isNil, isObject, isString } from '@pct-ts/typeguard';

interface BaseFile {
  file: File;
  isValid: boolean;
}

export interface ValidFile extends BaseFile {
  isValid: true;
}

export interface ErrorFile extends BaseFile {
  isValid: false;
  errorType: SelectedFileErrorType;
}

export type SelectedFile = ValidFile | ErrorFile;

export const selectedFileError = ['INVALID_TYPE', 'FILE_TOO_LARGE', 'TOO_MANY_FILES'] as const;
export type SelectedFileErrorType = (typeof selectedFileError)[number];

export function createValidFile(file: File): ValidFile {
  return {
    file,
    isValid: true,
  };
}

export function createErrorFile(file: File, errorType: SelectedFileErrorType): ErrorFile {
  return {
    file,
    isValid: false,
    errorType,
  };
}

export function isValidFile(file: unknown): file is ValidFile {
  return (
    isObject(file) &&
    !isNil(file) &&
    'file' in file &&
    'isValid' in file &&
    file.isValid === true &&
    file.file instanceof File
  );
}

export function isErrorFile(file: unknown): file is ErrorFile {
  return (
    isObject(file) &&
    !isNil(file) &&
    'file' in file &&
    'isValid' in file &&
    'errorType' in file &&
    file.isValid === false &&
    file.file instanceof File &&
    isString(file.errorType)
  );
}
